export default "__VITE_ASSET__YUKQcWVQ__"